import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Avertissement affiché à la connexion sur le compte personnel quand une fin
// de service a dû être clôturée automatiquement (service non clôturé dans les
// délais, voir check_missed_end_of_service côté serveur). Acquitté une seule
// fois, puis n'apparaît plus jusqu'au prochain oubli.
const EndOfServiceWarningModal = ({ user, onAcknowledged }) => {
  const [submitting, setSubmitting] = useState(false);

  const handleAcknowledge = async () => {
    setSubmitting(true);
    const token = localStorage.getItem('token');
    try {
      await fetch(`${BACKEND_URL}/api/auth/acknowledge-eos-warning`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` }
      });
    } catch { /* silencieux - on referme quand meme la popup */ }
    finally {
      setSubmitting(false);
      onAcknowledged({ ...user, pending_end_of_service_alert: false });
    }
  };

  return (
    <Dialog open={true} onOpenChange={() => {}}>
      <DialogContent
        className="max-w-md [&>button]:hidden"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-600 dark:text-red-400">
            <AlertTriangle className="h-5 w-5" />
            Fin de service non réalisée
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-3 text-sm text-slate-700 dark:text-slate-200">
          <p>
            Votre dernière prise de service n'a pas été suivie d'une fin de service dans les délais.
            Elle a été clôturée automatiquement par le système.
          </p>
          <p>
            Il est <strong>obligatoire</strong> de réaliser votre fin de service à chaque fois, avec
            signature, dès la fin de votre présence sur site. Des oublis répétés pourront entraîner
            des sanctions.
          </p>
          {user?.missed_end_of_service_count > 1 && (
            <p className="text-xs text-red-600 dark:text-red-400 font-medium">
              Ceci est le {user.missed_end_of_service_count}ᵉ oubli enregistré sur votre compte.
            </p>
          )}
        </div>

        <div>
          <Button
            type="button"
            className="btn-primary w-full mt-2"
            onClick={handleAcknowledge}
            disabled={submitting}
            data-testid="eos-warning-acknowledge-btn"
          >
            {submitting ? 'Enregistrement...' : "J'ai compris"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EndOfServiceWarningModal;
